function initInfiniteScroll() {
  const grid = document.querySelector('#ProductGridContainer .collection');
  let pagination = document.querySelector('.pagination-wrapper');
  if (!grid || !pagination) return;

  let nextLink = pagination.querySelector('a.pagination__item--prev');
  if (!nextLink) return;

  const observer = new IntersectionObserver(
    async (entries) => {
      if (entries[0].isIntersecting && nextLink) {
        observer.unobserve(entries[0].target);

        const url = nextLink.href;
        const response = await fetch(url);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newGrid = doc.querySelector('#ProductGridContainer .collection');
        const newProducts = newGrid ? Array.from(newGrid.children) : [];
        newProducts.forEach((prod) => grid.appendChild(prod));

        const newPagination = doc.querySelector('.pagination-wrapper');
        if (newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
          pagination = document.querySelector('.pagination-wrapper');
          nextLink = pagination.querySelector('a.pagination__item--prev');

          if (nextLink) {
            observer.observe(nextLink);
          }
        }
      }
    },
    { rootMargin: '200px' }
  );

  observer.observe(nextLink);
}

document.addEventListener('DOMContentLoaded', () => {
  initInfiniteScroll();
});

const originalRender = FacetFiltersForm.renderProductGridContainer;

FacetFiltersForm.renderProductGridContainer = function (html) {
  originalRender.call(this, html);
  initInfiniteScroll();
};
